<template>
  <mdb-modal class="text-center" size="sm">
    <mdb-modal-header :close="false" center class="secondary-color text-white">
      <h5>Please Wait</h5>
    </mdb-modal-header>
    <mdb-modal-body>
      <p>{{message}}</p>
      <mdb-spinner />
    </mdb-modal-body>
  </mdb-modal>
</template>
<script>
import {mdbModal, mdbModalBody, mdbModalHeader, mdbSpinner} from 'mdbvue';

export default {
    name: 'processingModal',
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbSpinner
    },
    props: {
      message: {
        type: String,
        default: "Processing..."
      },
    }
  };
</script>
